module.exports = __webpack_public_path__ + "img/target-savings-none.330ae36b.svg";